import { createAsyncThunk } from '@reduxjs/toolkit';
import { callGetAPI, callPostAPI, callPutAPI } from '../../services/axios';

export const getExaminations = createAsyncThunk(
	'getExaminations',
	async(params, { rejectWithValue }) => {
		try {
			const { type, ...newParams } = params;
			const response = await callGetAPI({ route: `hospital/sys-examination?type=${type}`, params: newParams });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const getExaminationDetails = createAsyncThunk(
	'getExaminationDetails',
	async(params, { rejectWithValue }) => {
		try {
			const { id } = params;
			const response = await callGetAPI({ route: `hospital/sys-examination/${id}` });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const createExamination = createAsyncThunk(
	'createExamination',
	async(params, { rejectWithValue }) => {
		try {
			const response = await callPostAPI({ route: 'hospital/sys-examination', body: params });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);

export const updateExamination = createAsyncThunk(
	'updateExamination',
	async(params, { rejectWithValue }) => {
		try {
			const { id, body } = params;
			const response = await callPutAPI({ route: `hospital/sys-examination/${id}`, body });
			return { response };
		} catch (err) {
			return rejectWithValue(err.response.data);
		}
	},
);